import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import {Card, CardText, CardActions} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import Snackbar from 'material-ui/Snackbar';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import createHistory from 'history/createBrowserHistory';
import StandTag from './StandTag';
import StandDelete from './StandDelete';
import StandDuplicate from './StandDuplicate';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import StandTagWithLabel from './StandTagWithLabel';

class StandCard extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      standKey: null,
      nameErrorText: '',
      stand: {
        key: '',
        name: '',
        description: '',
        coordinates: '',
        standTag: {
          code: ''
        }
      },
      snackbarOpen: false,
      standTagDialogOpen: false,
      standDeleteDialogOpen: false,
      noTagAlertOpen: false
    };

    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    const {standKey} = this.props;
    const {shopkeeperId} = this.props.user;
    if (standKey && shopkeeperId) {
      this.setState({standKey});
      this.getStand(standKey, shopkeeperId);
    }
  }

  getStand = (standKey, shopkeeperId) => {
    const {firebase} = this.props;
    firebase
      .database()
      .ref(`shopkeepers/${shopkeeperId}/stands/${standKey}`)
      .once('value')
      .then((data) => {
        const stand = {
          key: standKey,
          ...data.val()};

        const noTagAlertOpen = (stand.standTag && stand.standTag.code) ? false : true;

        this.setState({stand,  noTagAlertOpen});
      });

  }

  handleSave = () => {
    const {firebase, user} = this.props;

    if (this.validateName) {

      const stand = {
        name: this.state.stand.name,
        description: this.state.stand.description,
        coordinates: this.state.stand.coordinates
      };

      const {standKey} = this.state;

      firebase.database()
        .ref(`shopkeepers/${user.shopkeeperId}/stands/${standKey}`)
        .update(stand);

      firebase.database()
        .ref(`shopkeepers/${user.shopkeeperId}/standsList/${standKey}`)
        .update(stand);

      this.setState({snackbarOpen: true});
    }
  }
  validateName = () => {
    const {t} = this.props;
    if (this.state.stand.name) {
      return true;
    } else {
      this.setState({nameErrorText:t('stand.nameRequired')});
      return false;
    }
  }
  handleNameChange = (event, name) => {
    this.setState({nameErrorText: '', stand: {...this.state.stand, name}});
  }
  handleDescriptionChange = (event, description) => {
    this.setState({stand: {...this.state.stand, description}});
  }
  handleCoordinatesChange = (event, coordinates) => {
    this.setState({stand: {...this.state.stand, coordinates}});
  }
  closeSnackbar = () => {
    this.setState({snackbarOpen: false,});
  }
  handleStandTagDialogOpen = () => {
    this.setState({standTagDialogOpen: true});
  }
  handleStandTagDialogClose = () => {
    this.setState({standTagDialogOpen: false});
  }
  handleStandDeleteDialogOpen = () => {
    this.setState({standDeleteDialogOpen: true});
  }
  handleStandDeleteDialogClose = () => {
    this.setState({standDeleteDialogOpen: false});
  }
  openTagDialog = () => {
    this.setState({noTagAlertOpen: false, standTagDialogOpen: true});
  }

  render()  {
    const {t} = this.props;

    const tag = this.state.stand.standTag ?
    <StandTagWithLabel code={this.state.stand.standTag.code}/>
     : null;

    return (
      <Card className='cardStyle' >
        <Toolbar>
          <ToolbarGroup firstChild={true}>
            <IconButton onTouchTap={createHistory().goBack}>
              <ArrowBack color="rgba(0,0,0,0.4)" />
            </IconButton>
            <ToolbarTitle text={t('stand.stand')} />
          </ToolbarGroup>
          <ToolbarGroup lastChild={true}>
              <IconMenu
                iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
                useLayerForClickAway={true}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                <StandDuplicate stand={this.state.stand} />
                <MenuItem
                  primaryText={t('stand.delete')}
                  onTouchTap={this.handleStandDeleteDialogOpen}/>
                <MenuItem
                  primaryText={t('stand.tag')}
                  onTouchTap={this.handleStandTagDialogOpen}/>
              </IconMenu>
            <StandDelete handleClose={this.handleStandDeleteDialogClose} open={this.state.standDeleteDialogOpen} stand={this.state.stand}/>
            <StandTag handleClose={this.handleStandTagDialogClose} open={this.state.standTagDialogOpen} stand={this.state.stand}/>
          </ToolbarGroup>
        </Toolbar>
            <CardText>
              {tag}
              <TextField hintText={t('stand.name')}
                floatingLabelText={t('stand.name')}
                errorText={this.state.nameErrorText}
                onChange={this.handleNameChange}
                onBlur={this.validateName}
                value={this.state.stand.name}
              />
              <br />
              <TextField hintText={t('stand.description')}
                floatingLabelText={t('stand.description')}
                onChange={this.handleDescriptionChange}
                value={this.state.stand.description}
              />
              <br />
              <TextField hintText={t('stand.coordinates')}
                floatingLabelText={t('stand.coordinates')}
                onChange={this.handleCoordinatesChange}
                value={this.state.stand.coordinates}
              />
            </CardText>
            <CardActions>
              <RaisedButton label={t('save')} primary  onTouchTap={this.handleSave} />
            </CardActions>

        <Dialog
          title={t('stand.noTagAddedTitle')}
          actions={[
            <FlatButton
              label={t('cancel')}
              onTouchTap={() => this.setState({noTagAlertOpen: false})}
            />,
            <FlatButton
              label={t('stand.tag')}
              primary={true}
              keyboardFocused={true}
              onTouchTap={this.openTagDialog}
            />,
          ]}
          modal={false}
          open={this.state.noTagAlertOpen}
          onRequestClose={() => this.setState({noTagAlertOpen: false})}
        >
          {t('stand.noTagAddedDescription')}
        </Dialog>

        <Snackbar
          open={this.state.snackbarOpen}
          message={t('stand.saved')}
          autoHideDuration={4000}
          onRequestClose={this.closeSnackbar}
        />

      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(StandCard);



// WEBPACK FOOTER //
// ./src/Stand/StandCard.js